import { Spin } from "antd"
import { LoadingOutlined } from '@ant-design/icons';
import styles from "./index.module.scss"
import { ExtractionContext, ExtractionContextProvider } from "../ExtractionContext"
import useResizeObserver from "@utils/useResizeObserver"
import { forwardRef, useContext, useEffect, useImperativeHandle, useMemo, useState } from "react";
import ExtractionHead from "../ExtractionHead";
import ExtractionContent from "../ExtractionContent";
import UtilsEdit from '@utils/utils_edit'

const SingleExtraction = forwardRef((props, ref) => {
    useImperativeHandle(ref, () => ({
        onSubmit: () => context
    }))

    const context = useContext(ExtractionContext)
    const {
        modelBlueMaskBase64,
        modelBlendedMask,
        contentWidth, setContentWidth,
        contentHeight, setContentHeight,
        imageWidth,
        imageHeight,
    } = context
    useEffect(() => {
        props.onChange(!!modelBlueMaskBase64)
    }, [modelBlueMaskBase64])
    // 容器尺寸
    const [wrapWidth, setWrapWidth] = useState(0)
    const [wrapHeight, setWrapHeight] = useState(0)
    const targetRef = useResizeObserver((entries) => {
        for (let entry of entries) {
            // 处理尺寸变化的逻辑
            setWrapWidth(entry.contentRect.width)
            setWrapHeight(entry.contentRect.height)
        }
    })

    useEffect(() => {
        if (!(wrapWidth * wrapHeight)) return
        if (!(imageWidth * imageHeight)) return
        const size = UtilsEdit.getImgMaxSizeInContainer(
            imageWidth, imageHeight,
            wrapWidth / 2, wrapHeight
        )
        setContentWidth(size.width)
        setContentHeight(size.height)
    }, [wrapWidth, wrapHeight, imageWidth, imageHeight])
    const dimensionReady = useMemo(() => {
        return imageWidth * imageHeight && contentWidth * contentHeight
    }, [imageWidth, imageHeight, contentWidth, contentHeight])

    return (
        <div className={styles.Container}>
            <div className={styles.Head}>
                <ExtractionHead
                    uid={props.uid}
                    loading={props.loading}
                    onCancel={props.onCancel}
                    onFinish={props.onFinish}
                    uploadCb={props.uploadCb}
                />
            </div>
            <div className={styles.Content} ref={targetRef}>
            {
                !props.loading &&
                <ExtractionContent
                    key={props.uid}
                    uid={props.uid}
                    dimensionReady={dimensionReady}
                />
            }
            </div>
            {
                props.loading &&
                <div className={styles.Loading}>
                    <Spin tip="Loading" size="small" />
                    <p>抠图中...</p>
                </div>
            }
        </div>
    )
})


export default forwardRef((props, ref) => {
    return (
        <ExtractionContextProvider
            inputImage={props.inputImage}
            imageWidth={props.imageWidth}
            imageHeight={props.imageHeight}
            multiMasks={props.multiMasks}
            editedMask={props.editedMask}
            editedMaskBase64={props.editedMaskBase64}
            interactiveNpy={props.interactiveNpy}
        >
            <SingleExtraction ref={ref} {...props} />
        </ExtractionContextProvider>
    )
})